import { URLs } from '.'
import * as pages from '../pages'

export const personalUrls: URLs = {
  travelInfo: {
    urls: {
      default: '/trip/:slug/travelinformation',
      nl: '/trip/:slug/reisinformatie',
      be: '/trip/:slug/reisinformatie',
      de: '/trip/:slug/reiseinformationen',
      dk: '/trip/:slug/rejseinformation',
    },
    component: pages.TripInfo,
  },
  follower: { urls: { default: '/trip/:slug' }, component: pages.Follower },
  follower_with_code: {
    urls: { default: '/trip/:slug/:code' },
    component: pages.Follower,
  },
  pin: { urls: { default: '/unlock/:slug' }, component: pages.Pin },
}

export const pageNames = Object.keys(personalUrls)
